import { Injectable } from '@angular/core';
import {
  AspectType,
  ErrorMessage,
  FlyoutStatusTracker
} from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  AuxiliaryNavigationAemItem,
  getAuxiliaryNavigation,
  HeaderFooterMachCore,
  MyFlightPanelAem,
  NotificationAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  DefaultErrorLabel,
  LoadingLabel,
  MyFlightPanelLabel,
  SkyMilesMemberLabel
} from '../../models/constants/status-tracker/status.tracker.constants';
import {
  StatusTracker,
  TierMapping
} from '../../models/interfaces/status-tracker/status-tracker.interfaces';
@Injectable({
  providedIn: 'root'
})
export class FlyoutStatusTrackerAdapterService {
  medallionUrl = '';
  aemContent = {} as HeaderFooterMachCore;
  myFlightPanel: AuxiliaryNavigationAemItem = {} as AuxiliaryNavigationAemItem;
  notificationPanel: AuxiliaryNavigationAemItem =
    {} as AuxiliaryNavigationAemItem;

  getContent(
    trackerContent: StatusTracker,
    content: HeaderFooterMachCore
  ): FlyoutStatusTracker {
    this.aemContent = content;
    this.myFlightPanel =
      getAuxiliaryNavigation(this.aemContent, MyFlightPanelLabel) ??
      ({} as AuxiliaryNavigationAemItem);
    this.notificationPanel =
      getAuxiliaryNavigation(this.aemContent, 'notification') ??
      ({} as AuxiliaryNavigationAemItem);
    const trackerContentDeepCopy = JSON.parse(JSON.stringify(trackerContent));
    this.setTierLevelUrl(trackerContentDeepCopy);
    const deepCopyTrackerContent = this.transformAuraContent(
      trackerContentDeepCopy
    );
    return {
      details: deepCopyTrackerContent,
      errors: this.transformErrorMessage(trackerContent.error),
      loadingLabel:
        (this.notificationPanel as NotificationAem)?.loadingLabel ??
        LoadingLabel
    };
  }

  getErrorContent(
    trackerContent: StatusTracker,
    content: HeaderFooterMachCore
  ): FlyoutStatusTracker {
    this.aemContent = content;
    this.myFlightPanel = getAuxiliaryNavigation(
      this.aemContent,
      MyFlightPanelLabel
    ) as MyFlightPanelAem;
    this.notificationPanel =
      getAuxiliaryNavigation(this.aemContent, 'notification') ??
      ({} as AuxiliaryNavigationAemItem);
    return {
      details: {} as StatusTracker,
      errors: this.transformErrorMessage(trackerContent.error),
      loadingLabel:
        (this.notificationPanel as NotificationAem)?.loadingLabel ??
        LoadingLabel
    };
  }

  setTierLevelUrl(res: StatusTracker): void {
    const myFlightPanel = this.myFlightPanel as MyFlightPanelAem;
    if (
      myFlightPanel &&
      myFlightPanel.medallion &&
      myFlightPanel.medallion.length > 0
    ) {
      myFlightPanel.medallion.find((tierLevel) => {
        if (
          tierLevel.medallionId ===
          this.getTierName(res.header.subtitle ?? SkyMilesMemberLabel)
        ) {
          this.medallionUrl = tierLevel.medallionUrl;
        }
      });
    }
  }

  getTierName(name: string): string {
    const tier: TierMapping = {
      'Gold Medallion': 'GM',
      'Silver Medallion': 'FO',
      'Diamond Medallion': 'DM',
      'Platinum Medallion': 'PM',
      'SkyMiles Member': 'FF'
    };
    return tier[name as keyof TierMapping];
  }

  // TODO: (Keerthika) Remove Journey related aspect, more, qualifier as string. Code clean up required due to omnichannel changes also present.
  transformAuraContent(content: StatusTracker): StatusTracker {
    content.header.aspect = 'collapse';
    content.aspect = 'collapse';
    content.header.action = {
      label: content.header.subtitle ?? SkyMilesMemberLabel,
      url: this.medallionUrl
    };
    const sentence = content.header.title.toLowerCase();
    const words = sentence.split(' ');
    const capitalizedWords = words.map(
      (word: string) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    const capitalizedSentence = capitalizedWords.join(' ');
    content.header.title = capitalizedSentence;
    return content;
  }

  transformErrorMessage(error?: ErrorMessage): ErrorMessage {
    if (error && error.message) {
      const contentErrorMessage: ErrorMessage = {
        ...error,
        aspect: 'collapse' as AspectType,
        action: {
          label: error.action?.label ?? DefaultErrorLabel,
          url: this.getTrackerEarnStatusUrl(error)
        }
      };
      return contentErrorMessage;
    }
    return {} as ErrorMessage;
  }

  getTrackerEarnStatusUrl(error: ErrorMessage): string {
    return error.action?.url || '';
  }
}
